<template>
  <div class="d-flex status-bar-metrics">
    <status-bar-chart
      :value="fps"
      :low-value-threshold="30"
      class="py-1 ml-2"
      :width="60"
      :interval="1000"
      :max-history="20"
      show-value
      value-unit="fps"
    />
    <status-bar-chart
      :value="usedJSHeapSize"
      class="py-1 ml-2"
      :width="60"
      :interval="1000"
      :max-history="20"
      show-value
      value-unit="MB"
      :value-decorator="size"
    />
  </div>
</template>

<script>
import { useFps, useMemory } from "@vueuse/core"
import { computed } from "vue"
import StatusBarChart from "./statusBarChart.vue"

export default {
  name: "StatusBarMetrics",
  components: {
    StatusBarChart,
  },
  setup() {
    const { memory } = useMemory()
    const usedJSHeapSize = computed(() => memory.value?.usedJSHeapSize || 0)
    const fps = useFps()

    function size(v) {
      const kb = v / 1024 / 1024
      return `${kb.toFixed(2)}`
    }

    return {
      usedJSHeapSize,
      fps,
      size,
    }
  },
}
</script>

<style scoped>
.status-bar-metrics {
  height: 100%;
}
</style>
